import * as R from 'ramda';

import { always, cond, equals, lensPath, pathOr, set } from "ramda";
import { generateUniqueID } from "src/features/helper";
import { returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';

export const isPointsAsSymbol = (value: string) => {
  return cond([
    [equals('positive'), always('+')],
    [equals('negative'), always('-')],
  ])(value);
};
export const hasNumber = (str: string) => {
  return /\d/.test(str);
};

/**
 * This function applies compose function to a list of functions.
 * parameters: 1- funcList: list of functions
 * */

export const composeList = (funcList: any[]) => R.compose.apply(R, funcList);

export const setSessionId = (data: any) => {
  return returnIsNotEmptyOrTrue(
    pathOr('', ['id'], data),
    data,
    set(lensPath(['id']), `SESSION-${generateUniqueID()}`)(data)
  )
};